import React, { useEffect, useState } from 'react';
import { Plus, Search, Filter, Edit2, Trash2, Eye, Phone, Mail, Calendar, MapPin, User, Users, Clock, BookOpen, Star, ChevronRight, X, Save, UserPlus, History, MessageCircle, Video, FileText, AlertCircle, CheckCircle, XCircle } from 'lucide-react';
import useClientesModel from '../../../modelos/Clientes/modeloClientes';
import ModalAgregarCliente from './addCliente';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import { useNavigate } from 'react-router-dom';
import { formatearPrecio } from '../../../utils/utils';

const ModuloClientes = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const {configuracion, loadingConfiguracion} = useConfiguracion();
  const navigate = useNavigate();

  const {
    addCliente,
    clientes,
    cargarClientesBusqueda,
    loadingClientes,
    errorClientes,
    handleInputChange,
  } = useClientesModel();

  useEffect(() =>{
    //actualizar con configuracion y numero de telefono
    console.log("configuracion",configuracion);
    cargarClientesBusqueda(configuracion.nombreEmpresa,'');
  },[]);

 const filteredClients = clientes;


  const busquedaNunero = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    
    // Buscar automáticamente después de 2 caracteres
    if (value.length >= 2) {
      handleInputChange(value);
    } else if (value.length === 0) {
      // Limpiar resultados si está vacío
      handleInputChange([]);
    }
  };

  const handleClienteAgregado = (nuevoCliente) =>{
    console.log("vamos a agregar cliente",nuevoCliente,configuracion.nombreEmpresa);

    addCliente(configuracion.nombreEmpresa,nuevoCliente);
  }

  const redireccionEdicionCliente = (cliente) =>{
    navigate(`/clientes/detalle_cliente/${configuracion.nombreEmpresa}/${cliente.numero}`);
  }

  return (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">

    <ModalAgregarCliente 
      isOpen={showAddModal}
      onClose={() => setShowAddModal(false)}
      onClienteAgregado={handleClienteAgregado}
    />

    {/* Header mejorado */}
    <div className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">DUFY ASESORÍAS - 2.0</h1>
            <p className="text-gray-600 text-sm mt-1">Sistema de Gestión de Clientes</p>
          </div>
          <button 
            onClick={() => setShowAddModal(true)}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl transition-all duration-200 font-semibold flex items-center gap-2 shadow-lg hover:shadow-xl"
          >
            <Plus className="w-5 h-5" />
            Añadir Nuevo Cliente
          </button>
        </div>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-6 py-6">
      
      {/* Buscador mejorado */}
      <div className="bg-white rounded-2xl shadow-lg p-6 mb-8 border border-gray-100">
        <div className="flex flex-col lg:flex-row gap-4 items-center">
          <div className="flex-1 relative">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              type="text"
              placeholder="Buscar por número de teléfono o nombre..."
              className="w-full pl-12 pr-4 py-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-lg"
              value={searchTerm}
              onChange={busquedaNunero}
            />
          </div>
          <div className="flex items-center text-sm text-gray-500">
            <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full font-medium">
              {filteredClients.length} cliente{filteredClients.length !== 1 ? 's' : ''} encontrado{filteredClients.length !== 1 ? 's' : ''}
            </span>
          </div>
        </div>
      </div>

      {/* Grid de clientes mejorado */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredClients.map(cliente => (
          <div key={cliente.id} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 p-6 hover:border-blue-200">
            
            {/* Header de la carta */}
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  {cliente.nombreCliente.charAt(0).toUpperCase()}
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg">{cliente.nombreCliente}</h3>
                  <p className="text-sm text-gray-500">{cliente.nombrecompletoCliente || 'Sin nombre completo'}</p>
                </div>
              </div>
              <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs font-medium">
                Activo
              </span>
            </div>

            {/* Información de contacto */}
            <div className="mb-4 p-3 bg-gray-50 rounded-xl">
              <div className="flex items-center gap-2 mb-2">
                <Phone className="w-4 h-4 text-blue-600" />
                <span className="text-sm font-medium text-gray-700">{cliente.numero}</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-green-600" />
                <span className="text-sm text-gray-600">{cliente.universidad || 'Sin universidad'}</span>
              </div>
            </div>

            {/* Estadísticas */}
            <div className="grid grid-cols-3 gap-2 mb-4">
              <div className="text-center p-3 bg-blue-50 rounded-xl">
                <p className="text-lg font-bold text-blue-600">{cliente.estadisticasCliente.totalServicios}</p>
                <p className="text-xs text-gray-600"> # Servicios</p>
              </div>
              <div className="text-center p-3 bg-purple-50 rounded-xl">
                <p className="text-lg font-bold text-purple-600">{cliente.estadisticasCliente.totalSolicitudes}</p>
                <p className="text-xs text-gray-600"># Solicitudes</p>
              </div>
              <div className="text-center p-3 bg-green-50 rounded-xl">
                <p className="text-lg font-bold text-green-600">{formatearPrecio(cliente.estadisticasCliente.gastoTotal)}</p>
                <p className="text-xs text-gray-600"> $ Invertido</p>
              </div>
              <div className="text-center p-3 bg-purple-50 rounded-xl">
                <p className="text-lg font-bold text-purple-600">{cliente.estadisticasCliente.conversionSolicitudesServicio}</p>
                <p className="text-xs text-gray-600">% de agenda</p>
              </div>
            </div>

            {/* Información adicional */}
            <div className="mb-4 space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-500">Carrera:</span>
                <span className="text-gray-700 font-medium">{cliente.carrera || 'Sin especificar'}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-500">Procedencia:</span>
                <span className="text-gray-700 font-medium">{cliente.procedencia || 'Sin especificar'}</span>
              </div>
              {cliente.campanaRealizada && (
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-500">Campaña:</span>
                  <span className="text-blue-700 font-medium text-xs bg-blue-100 px-2 py-1 rounded-full">
                    {cliente.campanaRealizada}
                  </span>
                </div>
              )}
            </div>

            {/* Botones mejorados */}
            <div className="flex gap-3">
              <button 
                onClick={() => {
                  redireccionEdicionCliente(cliente);
                }}
                className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 font-semibold text-sm"
              >
                <History className="w-4 h-4" />
                Historial de cliente y edicion
              </button>
              
            </div>
          </div>
        ))}
      </div>

      {/* Mensaje cuando no hay resultados */}
      {filteredClients.length === 0 && searchTerm && (
        <div className="text-center py-12">
          <div className="w-24 h-24 bg-gray-100 rounded-full mx-auto mb-4 flex items-center justify-center">
            <Search className="w-12 h-12 text-gray-400" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No se encontraron clientes</h3>
          <p className="text-gray-500">Intenta con otro número de teléfono o nombre</p>
        </div>
      )}

    </div>

  </div>
  );

};

export default ModuloClientes;